import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        'SELF_MADE': 'SELF_MADE',
        'OPERATOR': 'OPERATOR',
      },
    }
  }
}